import type { Unit } from 'types/unit';

import config from 'configs/app';

const weiName = config.chain.currency.weiName || 'wei';

// [Basis MVP-NATIVE-1] The intermediate unit's name collapses with its scale.
// `G<base>` presumes Ethereum's ladder, where gwei sits nine orders above wei
// and nine below ether. On a chain with 9 or fewer decimals there is no middle
// rung -- 1e9 tomos IS one LITHOS -- so the label for that slot is the base
// unit's own name, matching INTERMEDIATE_EXP = 0 in toolkit/utils/consts.
export const currencyUnits: Record<Unit, string> = {
  wei: weiName,
  gwei: config.chain.currency.decimals > 9 ? `G${ weiName }` : weiName,
  ether: config.chain.currency.symbol || 'ETH',
};
